import { HTTPRequestMethods } from '../../Shared/httpRequestMethods';
import { convertObjectKeysToSnakeCase } from '../../Shared/ConvertObjectKeysToSnakeCase';
import { parseJsonResponse } from '../../Shared/parseJsonResponse';

export const getEnrollmentManagement = ({ onResponse, onError }) => {
  fetch('/api/admin/enrollment_management', {
    method: HTTPRequestMethods.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  })
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: 'error',
    });
  });
};

export const enrollFree = ({ body, onResponse, onError }) => {
  fetch('/api/admin/enrollment_management/enroll_free', {
    method: HTTPRequestMethods.POST,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
  })
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: 'error',
    });
  });
};

export const enrollPremiumFeeWaived = ({ body, onResponse, onError }) => {
  fetch('/api/admin/enrollment_management/enroll_premium_fee_waived', {
    method: HTTPRequestMethods.POST,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
  })
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: 'error',
    });
  });
};

export const upgradeToPremiumFeeWaived = ({ body, onResponse, onError }) => {
  fetch('/api/admin/enrollment_management/upgrade_to_premium_fee_waived', {
    method: HTTPRequestMethods.POST,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
  })
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: 'error',
    });
  });
};

export const downgradeToFree = ({ body, onResponse, onError }) => {
  fetch('/api/admin/enrollment_management/downgrade_to_free', {
    method: HTTPRequestMethods.POST,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
  })
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: 'error',
    });
  });
};
